import moment from 'moment';
import 'moment/locale/ar';
import 'moment/locale/tr';
import 'moment/locale/en-gb';
import Translator from '../../core/i18n';
import { Log } from 'ng2-logger';

const setupMoment = () => {

    const _logger = Log.create('moment-setup');
    const T = Translator.create();

    if (T.i18next.language === 'ar') {
        moment.updateLocale('ar', {
            calendar: {
                sameDay: '[اليوم] LT',
                nextDay: '[غداً] LT',
                nextWeek: 'dddd [الساعة] LT',
                lastDay: '[أمس] LT',
                lastWeek: 'dddd [الماضي الساعة] LT',
                sameElse: 'L'
            },
            longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd, D MMMM YYYY HH:mm'
            },
            postformat: function (string: string) {
                return string.replace(/[\u0660-\u0669]/g, function (c) {
                    return String.fromCharCode(c.charCodeAt(0) - 0x0660 + 48);
                });
            },
        });

    } else if (T.i18next.language === 'tr') {
        moment.updateLocale('tr', {
            // Eğer özel formatlar, takvim ayarları veya diğer ayarlar yapmak isterseniz buraya ekleyin
            calendar: {
                sameDay: '[Bugün] LT',
                nextDay: '[Yarın] LT',
                nextWeek: 'dddd [saat] LT',
                lastDay: '[Dün] LT',
                lastWeek: '[Geçen] dddd [saat] LT',
                sameElse: 'L'
            },
            longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd, D MMMM YYYY HH:mm'
            },
        });
    }
    else {
        moment.updateLocale('en', {
            calendar: {
                sameDay: '[Today] LT',
                nextDay: '[Tomorrow] LT',
                nextWeek: 'dddd [at] LT',
                lastDay: '[Yesterday] LT',
                lastWeek: '[Last] dddd [at] LT',
                sameElse: 'L'
            },
            longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd, D MMMM YYYY HH:mm'
            },
        });

    }

    // Set default locale
    moment.locale('en');

};

export default setupMoment;